import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { SavedCartDetailsActionComponent, SavedCartDetailsService } from '@spartacus/cart/saved-cart/components';
import {SavedCartFacade, SavedCartFormType} from '@spartacus/cart/saved-cart/root';
import {EventService, RoutingService, User} from '@spartacus/core';
import {LaunchDialogService} from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import {Cart} from '@spartacus/cart/base/root';
import {CheckoutQueryResetEvent} from "@spartacus/checkout/base/root";

@Component({
    selector: 'app-uig-saved-cart-details-action',
    templateUrl: './uig-saved-cart-details-action.component.html',
    styleUrls: ['./uig-saved-cart-details-action.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigSavedCartDetailsActionComponent extends SavedCartDetailsActionComponent implements OnInit, OnDestroy {
  private savedCartDetailsSubscription = new Subscription();

  @ViewChild('element') element: ElementRef;
  savedCart$: Observable<Cart | undefined> = this.savedCartDetailsService.getCartDetails();
  publicCart: boolean;
  activeCartForUser: boolean;
  saveTime: Date;
  disableActivateButton: boolean;
  isRestricted = false;
  RIO_CART_ORDER = 'rio_cart_order';
  RIO_CART_CREATE_UPDATE = 'rio_cart_create_update';
  private userSubscription = new Subscription();
  protected readonly SavedCartFormType = SavedCartFormType;

  constructor(
    protected savedCartDetailsService: SavedCartDetailsService,
    protected savedCartService: SavedCartFacade,
    protected vcr: ViewContainerRef,
    protected userAccountFacade: UserAccountFacade,
    protected launchDialogService: LaunchDialogService,
    protected routingService: RoutingService,
    protected eventService: EventService

  ) {
    super(savedCartDetailsService, vcr, launchDialogService);
  }

  ngOnInit(): void {
    this.checkForRoles();
    this.savedCartDetailsSubscription.add(
      this.savedCartService
        .getRestoreSavedCartProcessSuccess()
        .subscribe((success) => this.onRestoreComplete(success))
    );

    this.savedCart$.pipe(
      filter((cart) => cart != null),
      tap((cart) => {
        this.publicCart = cart.publicCart;
        this.activeCartForUser = cart.activeCartForUser;
        this.saveTime = cart.saveTime;
        this.disableActivateButton = this.deactivateButton(this.publicCart, this.activeCartForUser, this.saveTime);
      })
    )
      .subscribe();
  }

  onRestoreComplete(success: boolean): void {
    if (success) {
      this.routingService.go({ cxRoute: 'savedCarts' });
      this.savedCartService.clearRestoreSavedCart();
      this.savedCartService.clearSaveCart();
      this.eventService.dispatch({}, CheckoutQueryResetEvent);
    }
  }

  ngOnDestroy(): void {
    this.savedCartDetailsSubscription?.unsubscribe();
    this.userSubscription.unsubscribe();
  }

  deactivateButton(publicCart: boolean,
                   activeCartForUser: boolean,
                   saveTime: Date): boolean {
    return ((!saveTime && !publicCart) ||
      (!saveTime && publicCart && activeCartForUser));
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }

  restoreSavedCart(cartId: string): void {
    this.savedCartService.restoreSavedCart(cartId);
  }
}
